import axios from 'axios';
import React from "react";
import constants from "../../constants";
import Services from "../../services";

import { EyeFilled, EyeInvisibleFilled, MailFilled } from '@ant-design/icons';
import IconButton from '@material-ui/core/IconButton';
import InputAdornment from '@material-ui/core/InputAdornment';
import {
    makeStyles,
    withStyles
} from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';

//We can inject some CSS into the DOM
const styles = {
  root: {
    marginBottom: 10,
    height: 80,
    '& label.Mui-focused': {
      borderWidth: 2,
      color: '#646BDB',
      fontSize: '12px !important',
      fontWeight: '300 !important', //regular
      lineHeight: '0px !important'
    },
    '& .MuiOutlinedInput-input': {
      padding: '16px !important',
      fontSize: '14px !important'
    },
    '& .MuiInput-underline:after': {
      borderBottomColor: '#646BDB',
    },
    '& .MuiFormLabel-root': {
      fontSize: '12px !important',
      fontWeight: '300 !important',
      lineHeight: '0 !important'
    },
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: '#D6D6D6',
        borderWidth: 1,
        top: '-5px !important'
      },
      '&:hover fieldset': {
        borderColor: '#27272F',
        color: '#5d56b3'
      },
      '&.Mui-focused fieldset': {
        borderColor: '#646BDB',
      },
    },
    '& .MuiFormHelperText-root': {
      marginTop: '0px !important'
    },
    '& .MuiOutlinedInput-notchedOutline': {
      '& legend': {
        borderBottom: 'none !important'
      }
    }
  },
}

const CssTextField = withStyles(styles)(TextField);

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
  }
}));

export default function Input(props) {
  const classes = useStyles();
  const [values, setValues] = React.useState({
    showPassword: false
  });
  const [showEmailExist, setShowEmailExist] = React.useState(false);
  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  }


  const renderIcons = (props) => {
    if (props.type === "password") {
      return (
        <InputAdornment position="end">
          <IconButton

            aria-label="toggle password visibility"
            onClick={() => props.handleClickShowPassword()}
            onMouseDown={handleMouseDownPassword}
            edge="end"
          >
            {props.showPassword ? <EyeFilled /> : <EyeInvisibleFilled />}
          </IconButton>
        </InputAdornment>
      );
    } else if (props.type === "email") {
      return (
        <InputAdornment position="end" disablePointerEvents={true}>
          <IconButton
            edge="end" disabled={true}
          >
            <MailFilled />
          </IconButton>
        </InputAdornment>
      );
    } else {
      null
    }
  }

  const validate = ({ type, name, value, novalidate }) => {
    if (novalidate != "true") {
      switch (type) {
        case "text":
          if (name == "firstName" || name == "lastName") {
            //call validation service for the name
            return Services.validator.nameValidate(value);
          } else {
            //call validation service for the name
            return true;
          }
        // break;
        case "password":
          //call validation for password
          return Services.validator.passwordValidate(value);
        // break;
        case "email":
          //call validation for email
          return Services.validator.emailValidate(value);
        // break;
        default:
          return value ? true : false;
      }
    }
    else {
      return value ? true : false;
    }
  };

  const onChangeHandler = (props, event) => {
    props.getValid(
      props.name,
      validate({
        type: props.type,
        name: props.name,
        value: props.value,
        novalidate: props.novalidate
      })
    );
    return props.onChange(props.name, event.target.value);
  };

  function makeEmailCheck(value) {
    let reqObj = {
      email: value
    }
    const payload = {
      method: "post",
      url: constants.checkEmailExist,
      headers: {
        "Content-Type": "application/json",
      },
      data: reqObj
    }
    return axios(payload);
  }

  const renderErrorMessage = (props) => {
    var propType = props.type;
    if (!validate({ type: propType, name: props.name, value: props.value, novalidate: props.novalidate }) && props.value != null && props.value != "" && props.novalidate != "true") {
      return (
        <span className="error-msg">
          {(props.customErrMsg ? props.customErrMsg
            : "This is not a valid " + props.placeholder.toLowerCase())}
        </span>
      )
    }
    else if (props.checkEmailDuplicates) {
      makeEmailCheck(props.value).then((response) => {
        setShowEmailExist(true);
      }).catch((response) => {
        setShowEmailExist(false);
      });
    }
    if (showEmailExist) {
      return (
        <span className="error-msg">
          Email Id Already In Use.
        </span>
      )
    }
    else if (props.value === null || props.value === "") {
      return null
    }
  }

  return (
    <div className={classes.root + props.containerClass}>
      {props.type == "email" || props.type == "password" || props.type == "text" ? (
        <CssTextField
          className={(props.value != null && props.novalidate != "true" && !validate({
              type: props.type,name: props.name,value: props.value
            }) ? " text-input-field-error" : classes.margin)}
          type={props.showPassword && props.type === "password" ? 'text' : props.type}
          name={props.name}
          label={props.placeholder}
          fullWidth
          defaultValue={props.value}
          variant="outlined"
          id={props.id}
          onChange={event => onChangeHandler(props, event)}
          // onKeyDown={event => onChangeHandler(props, event)}
          onBlur={() =>
            props.getValid(props.name,validate({
                type: props.type, name: props.name,value: props.value,novalidate: props.novalidate})
            )
          }
          InputProps={{endAdornment: renderIcons(props)}}
          helperText={renderErrorMessage(props)}
        />
      ) : null}
      {props.type == "checkbox" ? (
        <p className="accept">
          <input
            className="styled-checkbox"
            id="styled-checkbox-1"
            type={props.type}
            value={props.value}
            name={props.name}
            onClick={event => props.onChange(props.name, event.target.checked)}
          />
          <label htmlFor="styled-checkbox-1"></label>
          {props.children}
        </p>
      ) : null}
    </div>
  );
}
